'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookMeeting = exports.createMeetingFailed = exports.createMeetingSucceeded = exports.createMeetingAction = exports.fetchCompanyNameFailed = exports.fetchCompanyNameSucceeded = exports.fetchCompanyNameAction = exports.fetchUserProfileFailed = exports.fetchUserProfileSucceeded = exports.fetchUserProfileAction = exports.fetchPublicAvailabilityInfoForOwnerFailed = exports.fetchPublicAvailabilityInfoForOwnerSucceeded = exports.fetchPublicAvailabilityInfoForOwnerAction = exports.fetchPublicAvailabilityInfoFailed = exports.fetchPublicAvailabilityInfoSucceeded = exports.fetchPublicAvailabilityInfoAction = exports.logMeetingCreation = undefined;
exports.fetchPublicAvailabilityInfo = fetchPublicAvailabilityInfo;
exports.fetchPublicAvailabilityInfoForOwner = fetchPublicAvailabilityInfoForOwner;
exports.fetchUserProfile = fetchUserProfile;
exports.fetchCompanyName = fetchCompanyName;
exports.getUserProfile = getUserProfile;
exports.createMeeting = createMeeting;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fluxActions = require('flux-actions');

var _actions = require('MeetingsBase/utils/actions');

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _Immutable = require('Immutable');

var _UIActions = require('./UIActions');

var _bookingAPI = require('MeetingsLib/api/bookingAPI');

var _utils = require('MeetingsLib/utils/utils');

var _PublicGlobalBrandingActions = require('MeetingsLib/redux/actions/PublicGlobalBrandingActions');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _RESTParamSelectors = require('MeetingsLib/selectors/RESTParamSelectors');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _MeetingsUser = require('MeetingsBase/models/MeetingsUser');

var _MeetingsUser2 = _interopRequireDefault(_MeetingsUser);

var _PublicAvailabilityInfo = require('MeetingsBase/models/PublicAvailabilityInfo');

var _PublicAvailabilityInfo2 = _interopRequireDefault(_PublicAvailabilityInfo);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

var _TimeRange = require('MeetingsBase/models/TimeRange');

var _TimeRange2 = _interopRequireDefault(_TimeRange);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _errors = require('MeetingsLib/constants/errors');

var _enums = require('MeetingsBase/constants/enums');

var _status = require('MeetingsLib/constants/status');

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logMeetingCreation = exports.logMeetingCreation = (0, _fluxActions.createAction)(_ActionTypes2.default.LOG_MEETING_CREATE);

var fetchPublicAvailabilityInfoAction = exports.fetchPublicAvailabilityInfoAction = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_STARTED);

var fetchPublicAvailabilityInfoSucceeded = exports.fetchPublicAvailabilityInfoSucceeded = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (response) {
  var postResponse = {
    customFormFields: _FormState2.default.customFieldsFromBookInfo(response),
    bookInfo: _PublicAvailabilityInfo2.default.from(response)
  };
  return postResponse;
});

var fetchPublicAvailabilityInfoFailed = exports.fetchPublicAvailabilityInfoFailed = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED, function (error) {
  return { error: error };
});

var fetchPublicAvailabilityInfoForOwnerAction = exports.fetchPublicAvailabilityInfoForOwnerAction = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_STARTED);

var fetchPublicAvailabilityInfoForOwnerSucceeded = exports.fetchPublicAvailabilityInfoForOwnerSucceeded = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED, function (response) {
  var postResponse = {
    customFormFields: _FormState2.default.customFieldsFromBookInfo(response),
    bookInfo: _PublicAvailabilityInfo2.default.from(response)
  };
  return postResponse;
});

var fetchPublicAvailabilityInfoForOwnerFailed = exports.fetchPublicAvailabilityInfoForOwnerFailed = (0, _actions.createRequestAction)(_ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_FAILED, function (error) {
  return { error: error };
});

var fetchWithEarlyRequestHook = function fetchWithEarlyRequestHook(fallbackFetch, requestName) {
  if (window.earlyRequester) {
    var earlyRequest = window.earlyRequester.getRequestStateByName(requestName);
    if (earlyRequest) {
      return new Promise(function (resolve, reject) {
        earlyRequest.whenFinished(function () {
          var mark = requestName + '-finished';
          if (window.performance && window.performance.mark && window.performance.measure) {
            window.performance.mark(mark);
            window.performance.measure(requestName + '-after-mount', 'create-booking-component', mark);
          }
          resolve.apply(undefined, arguments);
        });
        earlyRequest.onError(function () {
          return reject.apply(undefined, arguments);
        });
      });
    }
  }
  return fallbackFetch();
};

var createPublicAvailabilityFetcher = function createPublicAvailabilityFetcher(dispatch, getState, httpClient, params) {
  var state = getState();
  var slug = encodeURIComponent(state.userSlug);
  var queryParams = (0, _RESTParamSelectors.getFetchAvailabilityQueryParams)(params)(state);
  return function () {
    return (0, _bookingAPI.fetchPublicAvailabilityInfo)(httpClient, slug, queryParams);
  };
};

function fetchPublicAvailabilityInfo(params) {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchPublicAvailabilityInfoAction());
    var fetch = createPublicAvailabilityFetcher(dispatch, getState, httpClient, params);
    var fetchPromise = fetchWithEarlyRequestHook(fetch, 'book-info');
    return fetchPromise.then(function (response) {
      dispatch(fetchPublicAvailabilityInfoSucceeded(response));
      return _PublicAvailabilityInfo2.default.from(response);
    }, function (error) {
      dispatch(fetchPublicAvailabilityInfoFailed(error));
      // redirect users who try to hit meeting links on
      // www.hubspot.com when they are not hosted there
      if (error && error.status === _status.STATUS.NOT_FOUND) {
        (0, _utils.maybeRedirectToHubSpotDomain)(window.location.host);
      }
      return Promise.reject(error);
    });
  };
}

function fetchPublicAvailabilityInfoForOwner(params) {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchPublicAvailabilityInfoForOwnerAction());
    var fetch = createPublicAvailabilityFetcher(dispatch, getState, httpClient, params);
    return fetch().then(function (response) {
      dispatch(fetchPublicAvailabilityInfoForOwnerSucceeded(response));
      return _PublicAvailabilityInfo2.default.from(response);
    }, function (error) {
      dispatch(fetchPublicAvailabilityInfoForOwnerFailed(error));
      return Promise.reject(error);
    });
  };
}

var fetchUserProfileAction = exports.fetchUserProfileAction = (0, _actions.createRequestAction)(_ActionTypes2.default.USER_PROFILE_FETCH_STARTED);

var fetchUserProfileSucceeded = exports.fetchUserProfileSucceeded = (0, _actions.createRequestAction)(_ActionTypes2.default.USER_PROFILE_FETCH_SUCCEEDED, function (response) {
  return _MeetingsUser2.default.from(response);
});

var fetchUserProfileFailed = exports.fetchUserProfileFailed = (0, _actions.createRequestAction)(_ActionTypes2.default.USER_PROFILE_FETCH_FAILED, function (error) {
  return { error: error };
});

function fetchUserProfile(params) {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchUserProfileAction());
    var slug = encodeURIComponent(getState().userSlug);
    var includeInactiveLink = (0, _utils.shouldIncludeDeleted)(params);
    return fetchWithEarlyRequestHook(function () {
      return (0, _bookingAPI.fetchUserProfile)(httpClient, slug, includeInactiveLink);
    }, 'user-profile').then(function (response) {
      dispatch(fetchUserProfileSucceeded(response));
      return response;
    }, function (error) {
      dispatch(fetchUserProfileFailed(error));
      return Promise.reject(error);
    });
  };
}

var fetchCompanyNameAction = exports.fetchCompanyNameAction = (0, _actions.createRequestAction)(_ActionTypes2.default.COMPANY_NAME_FETCH_STARTED);

var fetchCompanyNameSucceeded = exports.fetchCompanyNameSucceeded = (0, _actions.createRequestAction)(_ActionTypes2.default.COMPANY_NAME_FETCH_SUCCEEDED, function (response) {
  return response.companyName;
});

var fetchCompanyNameFailed = exports.fetchCompanyNameFailed = (0, _actions.createRequestAction)(_ActionTypes2.default.COMPANY_NAME_FETCH_FAILED, function (error) {
  return { error: error };
});

function fetchCompanyName() {
  return function (dispatch, getState, httpClient) {
    dispatch(fetchCompanyNameAction());
    var slug = encodeURIComponent(getState().userSlug);
    return (0, _bookingAPI.fetchCompanyName)(httpClient, slug).then(function (response) {
      dispatch(fetchCompanyNameSucceeded(response));
      return response;
    }, function (error) {
      dispatch(fetchCompanyNameFailed(error));
    });
  };
}

function getUserProfile() {
  return function (dispatch, getState) {
    if ((0, _BookInfoSelectors.shouldFetchUserProfile)(getState())) {
      var params = { includeDeleted: 'true' };
      dispatch(fetchPublicAvailabilityInfo(params)).then(function (response) {
        if (response && response.linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN) && !(0, _getIn2.default)(['customParams', 'displayInfo', 'headline'], response)) {
          dispatch(fetchCompanyName());
        }
      }, function (error) {
        if (error && error.status === 404) {
          return;
        }

        throw error;
      }); // swallow 404, error is handled by UI
      return dispatch(fetchUserProfile(params)).then(function (response) {
        if (response) {
          dispatch((0, _PublicGlobalBrandingActions.fetchGlobalBranding)(response.portalId, response.userId));
        }
      }, function (error) {
        if (error && error.status === 404) {
          return;
        }

        throw error;
      }); // swallow 404, error is handled by UI
    }
    return Promise.resolve();
  };
}

var createMeetingAction = exports.createMeetingAction = (0, _actions.createRequestAction)(_ActionTypes2.default.MEETING_CREATE_STARTED);

var createMeetingSucceeded = exports.createMeetingSucceeded = (0, _actions.createRequestAction)(_ActionTypes2.default.MEETING_CREATE_SUCCEEDED, function (response) {
  var postResponse = new _Immutable.Map({
    timerange: _TimeRange2.default.from({
      start: response.start,
      end: response.end
    }),
    organizer: _UserProfile2.default.from(response.organizer)
  });
  return postResponse;
});

var createMeetingFailed = exports.createMeetingFailed = (0, _actions.createRequestAction)(_ActionTypes2.default.MEETING_CREATE_FAILED, function (error) {
  return { error: error };
});

var bookingTimeConflict = (0, _fluxActions.createAction)(_ActionTypes2.default.BOOKING_TIME_CONFLICT, function (userBusyTimes) {
  return { userBusyTimes: userBusyTimes };
}, function () {
  return (0, _actions.createRequestStatusMeta)(_ActionTypes2.default.MEETING_CREATE_UNINITIALIZED);
});

function createMeeting(event) {
  return function (dispatch, getState, httpClient) {
    dispatch(createMeetingAction());
    var state = getState();
    var slug = encodeURIComponent(state.userSlug);
    var data = (0, _RESTParamSelectors.getCreateMeetingBodyData)(event)(state);
    var queryParams = (0, _RESTParamSelectors.getCreateMeetingQueryParams)(state);

    return (0, _bookingAPI.createMeeting)(httpClient, slug, queryParams, data).then(function (response) {
      dispatch(createMeetingSucceeded(response));
      return response;
    }, function (error) {
      if (error.status === 400 && error.responseJSON && error.responseJSON.errorType === 'TIME_SLOT_NOT_AVAILABLE') {
        dispatch(bookingTimeConflict(error.responseJSON.userBusyTimes));
        throw Error(_errors.BOOKING_TIME_CONFLICT);
      }

      dispatch(createMeetingFailed(error));
      throw error;
    });
  };
}

var bookMeeting = exports.bookMeeting = function bookMeeting() {
  return function (dispatch, getState) {
    var state = getState();
    var isSalesStarter = state.isSalesStarter,
        _state$bookInfo = state.bookInfo,
        integration = _state$bookInfo.integration,
        linkType = _state$bookInfo.linkType,
        event = state.bookingLifecycle.event;

    var _getUserProfileSelect = (0, _BookInfoSelectors.getUserProfile)(state),
        email = _getUserProfileSelect.email;

    var submittingMeeting = (0, _RequestStatusSelectors.isSubmittingMeeting)(state);

    if (submittingMeeting) {
      return;
    }

    dispatch(createMeeting(event)).then(function () {
      dispatch(logMeetingCreation({
        integration: integration,
        linkType: linkType,
        isSalesStarter: isSalesStarter
      }));
    }, function (error) {
      if (error.message === _errors.BOOKING_TIME_CONFLICT) {
        dispatch((0, _UIActions.showUserMessage)({
          type: 'info',
          content: _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'errorMessages.bookedFromUnder' })
        }));
      } else {
        dispatch((0, _UIActions.showUserMessage)({
          type: 'danger',
          content: _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'errorMessages.tryAgain',
            options: { email: email }
          })
        }));
      }
    });
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/actions/BookActions.js
// module id = 89
// module chunks = 0